class LoginService {
  constructor (api) {
    this.API = api
  }

  setCorreoElectronico (correo) {
    this.correoElectronico = correo
  }

  setContrasena (contrasena) {
    this.contrasena = contrasena
  }

  async login () {
    const loginData = {
      correo_electronico: this.correoElectronico,
      contrasena: this.contrasena
    }
    try {
      const response = await this.API.post('/login', loginData)
      return response.data
    } catch (error) {
      console.log('error desde login: ', error)
      if (error.response && error.response.data) {
        throw new Error(JSON.stringify(error.response.data))
      } else {
        throw error
      }
    }
  }

  async refreshToken (refreshToken) {
    try {
      const response = await this.API.post('/refresh-token', { refresh_token: refreshToken })
      const newToken = response.data.token
      this.API.defaults.headers.common.Authorization = `Bearer ${newToken}`
      localStorage.setItem('token', newToken)
      return newToken
    } catch (error) {
      throw new Error('Error al renovar el token')
    }
  }
}

export default LoginService
